import React, { lazy } from "react";
import { Navigate } from "react-router-dom";

const Dashboard = lazy(() => import("../pages/Dashboard"));
const Orders = lazy(() => import("../pages/Orders"));
const OrderDetails = lazy(() => import("../pages/OrderDetails"));
const OrderCreate = lazy(() => import("../pages/OrderCreate"));
const Requisites = lazy(() => import("../pages/Requisites"));
const Treasury = lazy(() => import("../pages/Treasury"));
const Organization = lazy(() => import("../pages/Organization"));
const PlatformAdmin = lazy(() => import("../pages/PlatformAdmin"));

const Login = lazy(() => import("../pages/Authentication/Login"));
const Logout = lazy(() => import("../pages/Authentication/Logout"));
const Landing = lazy(() => import("../pages/Landing"));

const userRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/orders", component: <Orders /> },
  { path: "/orders/:orderId", component: <OrderDetails /> },
  { path: "/orders/create", component: <OrderCreate /> },
  { path: "/requisites", component: <Requisites /> },
  { path: "/treasury", component: <Treasury /> },
  { path: "/organization", component: <Organization /> },
  { path: "/platform-admin", component: <PlatformAdmin /> }
];

const authRoutes = [
  { path: "/", component: <Landing /> },
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "*", component: <Navigate to="/" /> }
];

export { userRoutes, authRoutes };